/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import axios from 'axios';
import qs from 'qs';
import Unauthenticated from '../errors/Unauthenticated';
import Unauthorized from '../errors/Unauthorized';

class RestHelper {
  static setConfig(config = {}) {
    return {
      'Content-Type': 'text/html; charset=ISO-8859-1',
      ...config
    };
  }
  static errorHandler(error) {
    if (error.response) {
      // The request was made, but the server responded with a status code
      // that falls out of the range of 2xx   );
      if (error.response.status * 1 === 401) {
        throw new Unauthenticated();
      } else if (error.response.status * 1 === 403) {
        throw new Unauthorized();
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error();
    }
  }
  static get(url, params = {}, config = {}) {
    const request = axios.get(url, params, this.setConfig(config));
    return request
      .then(response => response)
      .catch(this.errorHandler);
  }

  static post(url, params = {}, config = {}, noErrorHandler = false) {
    const request = axios.post(url, params, this.setConfig(config));
    if (noErrorHandler) {
      request.catch(this.errorHandler);
    }
    return request;
  }

  static postFormUrlEncoded(url, params = {}, config = {}, noErrorHandler = false) {
    const request = axios.post(url, qs.stringify(params), this.setConfig(config));
    if (noErrorHandler) {
      request.catch(this.errorHandler);
    }
    return request;
  }
}

export default RestHelper;
